import React from "react";
import { NavLink } from "react-router-dom";
import styles from "../static/styles/BottomNav.module.css";
// import homeImage from '../static/img/newLogo.png';
import homeImage from '../static/img/Sidebar/iconHome.svg';



const navItems = [
  {
    label: "Tasks",
    path: "/daily-gaming-tasks",
    icon: "/bottom-nav/tasks.png",
  },
  {
    label: "Tournaments",
    path: "/tournaments",
    icon: "/bottom-nav/tournaments.png",
  },

  /* CENTER ITEM */
  {
    label: "Home",
    path: "/",
    icon: homeImage,
    center: true,
  },

  {
    label: "Shop",
    path: "/rewards",
    icon: "/bottom-nav/shop.png",
  },
  {
    label: "Profile",
    path: "/profile",
    icon: "/bottom-nav/profile.png",
  },
];

const BottomNav = () => {
  return (
    <nav className={styles.bottomNav}>
      {navItems.map((item) => (
        <NavLink
          key={item.label}
          to={item.path}
          className={({ isActive }) =>
            `
              ${styles.navItem}
              ${isActive ? styles.active : ""}
              ${item.center ? styles.homeItem : ""}
            `
          }
        >
          <img
            src={item.icon}
            alt={item.label}
            className={styles.navIcon}
          />

          <span className={styles.navText}>{item.label}</span>

          <span className={styles.activeLine} />
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;